import { provideAnimations } from '@angular/platform-browser/animations';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { registerAllLocales } from './config/locale/register-locale';
import { BrandsEnum } from './_enums/brands.enum';
import { SdLibConfig } from './sd-lib-config';

registerAllLocales();

@NgModule()
export class SdLibModule {
  constructor(@Optional() @SkipSelf() parent: SdLibModule) {
    if (parent) {
      throw new Error('SdLibModule cannot be loaded twice!');
    }
  }

  static withBrand(brand: BrandsEnum): ModuleWithProviders<SdLibModule> {
    return {
      ngModule: SdLibModule,
      providers: [
        { provide: SdLibConfig, useValue: new SdLibConfig(brand) },
        provideAnimations()
      ]
    };
  }
}
